import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Typography, ListItemIcon, ListItemText, Collapse, List, ListItemButton } from '@mui/material';

// project import
import NavItem from '../NavItem';

// assets
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// ==============================|| NAV COLLAPSE ||============================== //

const NavCollapse = ({ menu, level }) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState(null);

  const handleClick = () => {
    setOpen(!open);
    setSelected(!selected ? menu.id : null);
  };

  const menus = menu.children.map((item) => {
    switch (item.type) {
      case 'collapse':
        return <NavCollapse key={item.id} menu={item} level={level + 1} />;
      case 'item':
        return <NavItem key={item.id} item={item} level={level + 1} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  const Icon = menu.icon;
  const menuIcon = menu.icon ? <Icon /> : <ArrowForwardIcon fontSize={level > 0 ? 'inherit' : 'default'} />;

  return (
    <>
      <ListItemButton
        sx={{
          borderRadius: '5px',
          mb: 0.6,
          // Ensure same left padding baseline
          pl: `${level * 16}px`,
          // Remove horizontal margin at level 1 to match single items
          mx: level > 1 ? 1 : 0,
          ...(level > 1 && { backgroundColor: 'transparent !important', py: 1, borderRadius: '5px' })
        }}
        selected={selected === menu.id}
        onClick={handleClick}
      >
        <ListItemIcon sx={{ 
          minWidth: !menu.icon ? '25px' : 'unset',
          color: theme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.87)' 
            : 'inherit'
        }}>
          {menuIcon}
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography 
              variant={selected === menu.id ? 'subtitle1' : 'body1'} 
              sx={{ 
                pl: 1.9,
                color: theme.palette.mode === 'dark' 
                  ? 'rgba(255, 255, 255, 0.87)' 
                  : 'inherit'
              }}
            >
              {menu.title}
            </Typography>
          }
          secondary={
            menu.caption && (
              <Typography 
                variant="caption" 
                sx={{ 
                  ...theme.typography.subMenuCaption, 
                  pl: 2,
                  color: theme.palette.mode === 'dark' 
                    ? 'rgba(255, 255, 255, 0.6)' 
                    : 'inherit'
                }} 
                display="block" 
                gutterBottom
              >
                {menu.caption}
              </Typography>
            )
          }
        />
        {open ? (
          <ExpandLess sx={{ 
            fontSize: '1rem',
            color: theme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.87)' 
              : 'inherit'
          }} />
        ) : (
          <ExpandMore sx={{ 
            fontSize: '1rem',
            color: theme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.87)' 
              : 'inherit'
          }} />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {menus}
        </List>
      </Collapse>
    </>
  );
};

NavCollapse.propTypes = {
  menu: PropTypes.object,
  level: PropTypes.number,
  title: PropTypes.string,
  icon: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.string
};

export default NavCollapse;
